import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginModule from "./modules/login/index.jsx";
import IndexModule from "./modules/index/index.jsx";
import ManagersModule from "./modules/managers/index.jsx";
import PasswordChangeModule from "./modules/password-change/index.jsx";

const hasLogin = () => {
  const admin = localStorage.getItem("admin");
  const token = localStorage.getItem("token");
  return Boolean(admin && token);
};

const LoginRoute = () => {
  if (hasLogin()) {
    return <Navigate to="/" replace />;
  }
  return <LoginModule />;
};

const ProtectedRoute = () => {
  if (!hasLogin()) {
    return <Navigate to="/login" replace />;
  }
  return <IndexModule />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginRoute />} />
        <Route path="/" element={<ProtectedRoute />}>
          <Route index element={<ManagersModule />} />
          <Route path="managers" element={<ManagersModule />} />
          <Route path="password/change" element={<PasswordChangeModule />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
